import {initialState} from '@ispm-client/modules/bpmn-modeler/store/state';
import {NodeActionTypes, NodesAction} from '@ispm-client/modules/bpmn-modeler/store/actions';

export function nodesCreationInfo(state = initialState.nodesCreationInfo, action: NodesAction) {
  switch (action.type) {
    case NodeActionTypes.NODES_INIT:
      return action.payload;
    case NodeActionTypes.NODE_CREATED:
      return {...state, [action.payload.id]: action.payload};
    case NodeActionTypes.NODE_UPDATED:
      const newState = {...state};
      newState[action.payload.id] = action.payload;
      return newState;
    case NodeActionTypes.NODE_DELETED:
      const nodeCreationResults = {...state};
      delete nodeCreationResults[action.payload.nodeId];
      return nodeCreationResults;
    case NodeActionTypes.NODE_COPY_TO_CLIPBOARD:
      return {...state, clipboard: {copiedObject: action.payload.clipboard.copiedObject , isContainNeighborhood: !!action.payload.clipboard.isContainNeighborhood}};
    case NodeActionTypes.NODE_CLIPBOARD_RESET:
      return {...state, clipboard: undefined };
    default: {
      return state;
    }
  }
}
